/**
 * Tabs
 *
 * Required props:
 * children
 *
 * Examples of component:
 * <Tabs>
 *   <li>First tab</li>
 *   <li>Second tab</li>
 * </Tabs>
 *
 */

import React from 'react';
import styled from 'styled-components';
import {
	colors,
	sidebarWidth,
	sidebarBreakpoint,
	totalHeaderHeight,
	topBarHeight,
} from '../../variables';

const Nav = styled.nav`
	position: fixed;
	top: ${totalHeaderHeight + 'px'};
	right: 0;
	z-index: 90;
	background: #fff;
	border-bottom: 1px solid ${colors.grey.normal};
	width: calc(100% - ${sidebarWidth + 'px'});

	@media (max-width: ${sidebarBreakpoint + 'px'}) {
		width: 100%;
		top: ${topBarHeight + 'px'};
	}
`;

const List = styled.ul`
	list-style: none;
	margin: 0;
	padding: 10px;
	padding-bottom: 0;
	overflow-x: auto;
	white-space: nowrap;
	font-size: 12px;

	&:before,
	&:after {
		position: absolute;
		top: 0;
		bottom: 0;
		width: 30px;
		content: '';
		background: linear-gradient(to right, #fff 10%, rgba(255, 255, 255, 0));
		display: block;
		pointer-events: none;
	}

	&:before {
		left: 0;
	}

	&:after {
		right: 0;
		transform: rotate(180deg);
	}
`;

class Tabs extends React.Component {
	render() {
		return (
			<Nav>
				<List>{this.props.children}</List>
			</Nav>
		);
	}
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/Common/Tabs/Tabs.js